import { TableFilterApiBody } from '../types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

export const getAllUsersList = async (payload: {
  page: number
  size: number
  sort?: string
  filter: TableFilterApiBody | undefined
}) => {
  return await axiosInstance.post(
    `${API_END_POINT.V2_CORE}users/advance`,
    payload.filter,
    {
      params: {
        sort: payload?.sort ?? 'enabled,DESC',
        size: payload.size,
        page: payload.page - 1,
      },
      headers: {
        'X-TenantId': '',
      },
    }
  )
}

export const columnSearchForUsers = async (payload: {
  filter: TableFilterApiBody | undefined
}) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}dropdown/filter-data/USER/USER_ID`,
    payload?.filter,
    {
      headers: {
        'X-TenantId': '',
      },
    }
  )
}
export const editUserProfile = async (payload: {
  userId: number
  profile: string
}) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}users/profile?userId=${payload.userId}&profile=${payload.profile}`
  )
}
export const toggleUserProfileById = async (payload: {
  id: number
  enabled: boolean
}) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}users/status?userId=${payload.id}&enable=${payload.enabled}`
  )
}
export const getUserProfiles = async () => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}users/fetchUserProfiles`,
    {
      headers: {
        'X-TenantId': '',
      },
    }
  )
}

export const validateUser = async (payload: { email: string }) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}users/validate?email=${payload.email}`
  )
}

export const addValidatedUser = async (payload: {
  oid?: string
  email?: string
  firstName?: string
  lastName?: string
}) => {
  return await axiosInstance.post(`${API_END_POINT.CORE}users/add`, {
    oid: payload.oid,
    email: payload.email,
    firstName: payload.firstName,
    lastName: payload.lastName,
  })
}
